//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'lodash';
import ClickOutside from '@/directives/ClickOutside';
import { isFilter, isProperty, isTime, valueEquals } from '@/helpers/util';
import Emitter from '@/mixins/emitter';
import Tooltip from '@/mixins/tooltip';
import DpDropdown from '../dropdown/Dropdown.vue';
import DpIcon from '../icon/Icon.vue';
import DpInput from '../input/Input.vue';
import DpSpinnerLoader from '../loader/SpinnerLoader.vue';

const SCROLL_INTO_VIEW_OPTIONS = {
  block: 'center',
  inline: 'center',
};

export default {
  name: 'DpSelect',
  directives: {
    ClickOutside,
  },
  components: {
    DpIcon,
    DpInput,
    DpSpinnerLoader,
    DpDropdown,
  },
  mixins: [Emitter, Tooltip],
  props: {
    value: { type: null, default: null },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    placeholder: { type: String, default: '' },
    size: { type: String, default: 'default' },
    clearable: { type: Boolean, default: false },
    fullWidth: { type: Boolean, default: false },
    filterable: { type: Boolean, default: false },
    minWidth: { type: Number, default: null },
  },
  data() {
    return {
      open: false,
      focus: false,
      query: '',
      options: [],
      focusedOption: null,
      focusedFilterInput: false,
      inputElement: null,
      scrollArea: null,
      isAbove: false,
    };
  },
  computed: {
    isFocus() {
      return this.open || this.focus;
    },
    currentSelectionText() {
      if (isFilter(this.value)) {
        return this.value.name;
      }
      if (isProperty(this.value)) {
        return this.value.alias;
      }

      let selectText = this.value;
      this.options.forEach((opt) => {
        if (_.isEqual(opt.val, this.value)) {
          selectText = opt.label || opt.val;
        }
      });
      return selectText;
    },
    currentSelectionIcon() {
      if (!this.value) {
        return null;
      }
      if (isTime(this.value)) {
        return 'time';
      }
      if (isFilter(this.value)) {
        return 'filter';
      }
      if (isProperty(this.value)) {
        if (this.value.isOnline) return 'time';
        if (this.value.isCalculated) return 'calculator';
        return this.value.metadata ? 'tag' : 'telemetry';
      }

      let icon = null;
      this.options.forEach((opt) => {
        if (opt.val === this.value) {
          ({ icon } = opt);
        }
      });

      return icon;
    },
    placeholderText() {
      if (!this.$t) return 'blah';
      if (this.loading) {
        return this.$t('ui.loadingOptions');
      }
      if (this.placeholder) {
        return this.placeholder;
      }
      return this.$t('ui.chooseOption');
    },
    isPlaceholder() {
      return this.value === undefined || this.value === null || this.value === '';
    },
    inputTabindex() {
      return this.open ? 0 : -1;
    },
    buttonsClass() {
      if (this.$slots.buttons) {
        switch (this.$slots.buttons.length) {
          case 0: return 'is-no-buttons';
          case 1: return 'is-one-button';
          case 2: return 'is-two-buttons';
          default: return '';
        }
      }
      return 'is-no-buttons';
    },
    topOffset() {
      // The height of the "current" box and the border offset
      if (this.size === 'small') {
        return 40;
      }
      if (this.size === 'large') {
        return 60;
      }
      return 50;
    },
    numberOfVisibleOptions() {
      return this.options.filter((opt) => opt.visible && !opt.disabled).length;
    },
  },
  watch: {
    value(newVal) {
      if (this.options) {
        this.options.forEach((opt) => {
          if (_.isEqual(opt.val, newVal)) {
            this.handleOptionClick(opt, true);
          }
        });
      }
    },
  },
  created() {
    this.$on('handleOptionClick', this.handleOptionClick);
    this.$on('handleButtonClick', this.handleButtonClick);
  },
  mounted() {
    // Grab the HTML elements in the select for focusing and scrollTo
    this.inputElement = this.$el.querySelector('.dp-input input');
  },
  beforeDestroy() {
    this.$off('handleOptionClick');
    this.$off('handleButtonClick');
  },
  methods: {
    registerOption(option) {
      this.options.push(option);
    },
    hide() {
      if (!this.open) {
        return;
      }
      this.open = false;
      this.handleBlur();
      this.enableTooltip();
    },
    show() {
      if (this.loading || this.disabled) {
        return;
      }
      this.disableTooltip();

      this.open = true;

      setTimeout(() => {
        this.$refs.dropdown.updatePosition();

        // Scroll selected option into view if there is no current focus
        if (this.focusedOption && this.focusedOption.$el) {
          this.focusedOption.$el.scrollIntoView(SCROLL_INTO_VIEW_OPTIONS);
        } else if (this.value) {
          let option;
          this.options.forEach((o) => {
            if (o.isSelected) {
              option = o;
            }
          });
          if (option) {
            option.$el.scrollIntoView(SCROLL_INTO_VIEW_OPTIONS);
          }
        }
      }, 10);

      // Setting the focus on the filter element appears to require a longer delay, perhaps
      // because of the opening animation
      setTimeout(() => {
        if (this.filterable && this.$refs.filter) {
          this.$refs.filter.focus();
        }
      }, 150);
    },
    handleBlur() {
      if (!this.open) {
        this.focus = false;
      }
    },
    handleClick() {
      if (!this.open) {
        this.show();
      } else {
        this.hide();
      }
    },
    handleQueryChange() {
      // Broadcast the changed filter to the options which then deal with their own visibility
      this.broadcast('DpOption', 'queryChange', this.query);
    },
    handleButtonClick() {
      this.hide();
    },
    handleClear() {
      this.$emit('clear');
      this.handleOptionClick({ val: null });
    },
    handleOptionClick(option, noFocus) {
      // Emit the changes
      this.$emit('input', option.val);
      this.emitChange(option.val);

      // Refocus on selected option
      this.focusedOption = option;
      this.broadcast('DpOption', 'focusChange', this.focusedOption);

      // Refocus on the select object, as is standard for <select> elements
      if (!noFocus) {
        this.$nextTick(() => {
          this.$el.focus();
          this.focus = true;
        });
      }
    },
    emitChange(val) {
      // If the value has been updated, emit the "change" emit
      if (!valueEquals(this.value, val)) {
        this.hide();
        this.$emit('change', val);
      }
    },
    selectPreviousOption() {
      if (this.options.length === 0) {
        return;
      }

      let focusOption = null;
      if (!this.focusedOption) {
        focusOption = this.options[this.options.length - 1];
      }

      if (focusOption !== null) {
        this.focusedOption = focusOption;
        this.broadcast('DpOption', 'focusChange', this.focusedOption);
      } else {
        let nextOpt = false;

        // Select the previous option based on the current focus
        for (let i = this.options.length - 1; i >= 0; i -= 1) {
          const opt = this.options[i];
          if (nextOpt && opt.visible && !opt.disabled) {
            focusOption = opt;
            nextOpt = false;
          } else if (opt.focused) {
            nextOpt = true;
          }
        }

        // Wrap around
        if (nextOpt === true) {
          focusOption = this.options[this.options.length - 1];
        }
      }

      if (focusOption !== null) {
        focusOption.$el.scrollIntoView(SCROLL_INTO_VIEW_OPTIONS);
        this.focusedOption = focusOption;
        this.broadcast('DpOption', 'focusChange', this.focusedOption);
      }
    },
    selectNextOption() {
      if (this.options.length === 0) {
        return;
      }

      let focusOption = null;

      // Select the next option based on the current focus
      if (!this.focusedOption || !this.focusedOption.val) {
        [focusOption] = this.options;
      } else {
        let nextOpt = false;
        this.options.forEach((o) => {
          if (nextOpt && o.visible && !o.disabled) {
            focusOption = o;
            nextOpt = false;
          } else if (o.focused) {
            nextOpt = true;
          }
        });

        // Wrap around
        if (nextOpt === true) {
          [focusOption] = this.options;
        }
      }

      if (focusOption !== null) {
        focusOption.$el.scrollIntoView(SCROLL_INTO_VIEW_OPTIONS);
        this.focusedOption = focusOption;
        this.broadcast('DpOption', 'focusChange', this.focusedOption);
      }
    },
    keyboardNavigate(key, event) {
      if (!this.open && !this.focus) {
        return;
      }

      // Hiding the dropdown
      if (key === 'esc') {
        this.hide();
        return;
      }

      // Opening the dropdown, or selecting an option
      if (key === 'enter' || key === 'space') {
        // Stop the spacebar from selecting an option if there is any query, as space may be
        // used to search
        if (this.focusedFilterInput && key === 'space') {
          if (this.query.replace(' ', '').length > 0) {
            return;
          }
          if (event) {
            event.preventDefault();
          }
        }

        if (!this.open && this.focus) {
          this.show();
        } else if (this.open && this.focusedOption) {
          this.handleOptionClick(this.focusedOption);
        }
      }

      // Navigating through the options list
      if (key === 'down') {
        this.selectNextOption();
      } else if (key === 'up') {
        this.selectPreviousOption();
      }
    },
  },
};
